import { PBRMaterial } from '@babylonjs/core/Materials/PBR/pbrMaterial';
import { Color3 } from '@babylonjs/core/Maths/math.color';
import { type Scene } from '@babylonjs/core/scene';
import { type IVector3 } from '@seddi/math-v2';

export class ThreadMaterial {
  static create(color: IVector3, scene: Scene) {
    const { x, y, z } = color;
    const materialId = `${x}-${y}-${z}`;

    const stitchMaterial = new PBRMaterial(materialId, scene);
    stitchMaterial.albedoColor = new Color3(x, y, z);
    stitchMaterial.metallic = 0.1;
    stitchMaterial.roughness = 0.9;
    stitchMaterial.sideOrientation = 1;
    return stitchMaterial;
  }
}
